//Style
import '../../styles/cv/card.scss'

// Language
import { useLanguage } from '../../context/language_context'


function Language() {

    const { language } = useLanguage()
    
    return (

        <div className='cv_card_details'>


            {/* LANGUAGES */}

            <div className='cv_card_title cv_card_skills'>

                <h3>
                    {language === 'fr'
                        ? 'Langues'
                        : 'Languages'}
                </h3>

                <ul>

                    <li>
                        <progress
                            id="language_french"
                            max="100"
                            value="100"
                        />

                        <label htmlFor="language_french">
                            {language === 'fr'
                                ? 'Français - langue maternelle'
                                : 'French - native language'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="language_english"
                            max="100"
                            value="95"
                        />

                        <label htmlFor="language_english">
                            {language === 'fr'
                                ? 'Anglais - C1/C2'
                                : 'English - C1/C2'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="language_korean"
                            max="100"
                            value="80"
                        />

                        <label htmlFor="language_korean">
                            {language === 'fr'
                                ? 'Coréen - B2'
                                : 'Korean - B2'}
                        </label>
                    </li>


                    <li>
                        <progress
                            id="language_german"
                            max="100"
                            value="25"
                        />

                        <label htmlFor="language_german">
                            {language === 'fr'
                                ? 'Allemand - A2/B1'
                                : 'German - A2/B1'}
                        </label>
                    </li>

                </ul>

            </div>


            {/* PROGRAMMING LANGUAGES */}

            <div className='cv_card_title cv_card_skills'>

                <h3>
                    {language === 'fr'
                        ? 'Langages de code'
                        : 'Programming languages'}
                </h3>

                <ul>

                    <li>
                        <progress
                            id="code_html"
                            max="100"
                            value="90"
                        />

                        <label htmlFor="code_html">
                            HTML, CSS, SCSS
                        </label>
                    </li>


                    <li>
                        <progress
                            id="code_javascript"
                            max="100"
                            value="80"
                        />

                        <label htmlFor="code_javascript">
                            JavaScript Vanilla, React, JSON
                        </label>
                    </li>


                    <li>
                        <progress
                            id="code_node"
                            max="100"
                            value="40"
                        />

                        <label htmlFor="code_node">
                            {language === 'fr'
                                ? 'NodeJS côté serveur'
                                : 'Server-side NodeJS'}
                        </label>
                    </li>

                </ul>

            </div>

        </div>
    )
}

export default Language